<style>
.display-flex {
    display: flex;
}

.display-inline {
    display: inline-block;
}

.align-to-right {
    justify-content: flex-end;
}

.align-to-left {
    justify-content: flex-start;
}

.align-to-center {
    justify-content: center;
}
</style>

<template>
    <div :class="displayClass">
        <div class="mb-4">
            <label>Time Span</label>
            <select class="block border rounded text-zinc-600" v-model="selectedTime" @change="onChange">
                <option value="1hr">1 hr</option>
                <option value="6hr">6 hr</option>
                <option value="12hr">12 hr</option>
                <option value="24hr">24 hr</option>
                <option value="today">Today</option>
                <option value="2days">2 Days</option>
                <option value="7days">7 Days</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="1mth">1 Month</option>
                <option value="3mth">3 Month</option>
                <option value="6mth">6 Month</option>
                <option value="quarter">This Quarter</option>
                <option value="year">This Year</option>
                <option value="1yr">1 Year</option>
            </select>
        </div>
    </div>
</template>

<script>

import {updateQuerySting, newLocation, getQueryValue} from '../lib/helpers';

export default {
    props: {
        display: String,
        align: String,
        defaultPeriod: String,
    },
    data() {
        return {
            displayType: this.display,
            alignType: this.align,
            selectedTime: 'today'
        }
    },
    beforeMount() {
        let _default = this.defaultPeriod;

        if(!_default) {
            _default = 'today';
        }

        this.selectedTime = getQueryValue('period', _default);
    },
    methods: {
        onChange() {
            const query = updateQuerySting('period', this.selectedTime);
            newLocation(null, query);
        },
    },
    computed: {
        displayClass() {

            switch(this.displayType)
            {
                case 'flex':
                    let baseClass = 'display-flex';
                    if(this.alignType === 'right') {
                        baseClass += ' align-to-right'
                    } 
                    else if(this.alignType === 'center')
                    {
                        baseClass += ' align-to-center'
                    }
                    else 
                    {
                        baseClass += ' align-to-left'
                    }
                    return baseClass;
                case 'inline':
                    return 'display-inline';
                default:
                    return 'display-inline'
            }
        },
    },
}
</script>

